import script from "./AdvertisingAcos.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertisingAcos.vue?vue&type=script&setup=true&lang=js"

import "./AdvertisingAcos.vue?vue&type=style&index=0&id=f1e0b952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1e0b952"]])

export default __exports__